import React, { useEffect, useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fetcher, { URLBuild } from '../../services/fetcher';
import settings from '../../settings';
import { Card, LinearProgress } from '@material-ui/core';
import { ResponsiveContainer, ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { StatByProfitwell } from './consts'

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
    paddingTop: '10px',
    textAlign: "center"
  },
  title: {
    fontSize: "1rem"
  }
}));

const bars = [
  { dataKey: "existing_customers", name: "clients existants", color: "#56A5C4" },
  { dataKey: "reactivated_customers", name: "clients réactivés", color: "#00B9A1" },
  { dataKey: "new_customers", name: "nouveaux clients", color: "#8884d8" },
  { dataKey: "active_trialing_customers", name: "clients en période d'essai", color: "#a0b8bf" },
  { dataKey: "churned_customers", name: "clients stoppés", color: "#ffa476", minus: true },
];

const fakeData = (new Array(12)).fill(1).map((_, index) => {
  const fakeBar = {
    name: (index + 1) + '/2022',
    new_customers: 0,
    reactivated_customers: 0,
    churned_customers: 0,
    active_trialing_customers: 0,
    existing_customers: 0,
    total: 0
  };
  return fakeBar;
});

const StripeAllChart = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(0);
  const [data, setData] = useState(fakeData);
  const [hideBars, setHideBars] = useState<{ [key: string]: boolean }>({});

  const refreshTotal = useCallback(() => {
    setData(prev => {
      const newData: any[] = []
      for (const val of prev) {
        let newTT = 0
        for (const bar of bars) {
          if (!hideBars[bar.dataKey])
            newTT += (val as any)[bar.dataKey] || 0
        }
        newData.push({ ...val, total: newTT })
      }
      return newData
    })
  }, [hideBars])

  const hideChartBar = useCallback((bar, legendIndex: number) => {
    setHideBars(prev => {
      const newState = Object.assign({}, prev)
      newState[bar.dataKey] = !prev[bar.dataKey] || false
      return newState
    });
  }, [])

  useEffect(() => {
    if (hideBars) refreshTotal()
  }, [hideBars])

  useEffect(() => {
    setLoading((prev) => prev + 1);
    const period = 'monthly'

    Fetcher.get(
      URLBuild(settings.PaymentProvider.paymentApi + '/stat-profitwell/metrics/' + period, {})
    ).then((fetched: { data: StatByProfitwell }) => {
      const newData: any[] = []
      const months = fetched.data[bars[0].dataKey].map(val => val.date)

      for (const month of months) {
        let stackBar: any = {}
        for (const bar of bars) {
          stackBar[bar.dataKey] = fetched.data[bar.dataKey].find(val => val.date === month)?.value || 0
          if (bar.minus) stackBar[bar.dataKey] = -stackBar[bar.dataKey]
        }

        newData.push({
          ...stackBar,
          name: month.split('-').reverse().join('/'),
          total: 0
        });
      }
  
      setData(newData)
      refreshTotal()
      setLoading((prev) => prev - 1);
    });
  }, [])

  return (
    <Card className={classes.container}>
      <span className={classes.title}>Clients actifs par mois</span>
      <div style={{height: '60vh'}}>
        <ResponsiveContainer>
          <ComposedChart
            width={500}
            height={400}
            data={data}
            margin={{
              top: 10,
              right: 20,
              bottom: 16,
              left: 0
            }}
          // barCategoryGap="1%"
          >
            <CartesianGrid stroke="#d5d5d5" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend onClick={hideChartBar} wrapperStyle={{ cursor: 'pointer' }} />
            {/* <Area type="monotone" dataKey="amt" fill="#8884d8" stroke="#8884d8" /> */}
            {
              bars.map((bar) => {
                return <Bar key={bar.dataKey} dataKey={bar.dataKey} name={bar.name} stackId="a" fill={bar.color} fillOpacity={0.8} hide={!!hideBars[bar.dataKey]} />
              })
            }
            <Line dataKey="total" type="monotone" stroke="#222" strokeWidth={2} hide={!!hideBars["total"]} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      {!!loading && <LinearProgress color="secondary" />}
    </Card>
  );
}

export default StripeAllChart;